// extracted by mini-css-extract-plugin
export var actionButton = "_dk-0";
export var attachmentLine = "_dk-1";
export var fileInput = "_dk-2";
export var fileUploadWrapper = "_dk-4";
export var footer = "_dk-3";
export var modalContent = "_dk-5";
export var paperclip = "_dk-6";
export var quillEditor = "_dk-7";